import { render, staticRenderFns } from "./relate.vue?vue&type=template&id=437142e4&"
import script from "./relate.vue?vue&type=script&lang=js&"
export * from "./relate.vue?vue&type=script&lang=js&"
import style0 from "./relate.vue?vue&type=style&index=0&id=437142e4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports